<template>
  <div class="td-cell-bg">
    <span
      :class="[
        row?.editFlag
          ? 'd-f justify-c align-c bg-f0f9eb'
          : 'd-f justify-c align-c',
      ]"
    >
      <el-tag
        v-if="row?.returnNum > 0 && row?.repeatId == null"
        style="
          width: 76px;
          height: 23px;
          color: #00bfbf;
          background-color: #ffffff;
        "
        type="info"
      >
        打回任务池
      </el-tag>
      <div style="text-align: center">
        <div v-if="row?.repeatId || row?.wordCount === 0">无需处理</div>
        <section v-else>
          <div v-if="row?.qcStatus == -1">审核中</div>
          <div v-if="row?.qcStatus == 1">未处理</div>
          <div v-if="row?.qcStatus == 2">已修改</div>
          <div v-if="row?.qcStatus == 3">已阅无误</div>
        </section>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'QcStatusColumn',
  props: ['row', 'currentRow'],
};
</script>
